var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.428 12.4867L11.2659 10.3246C11.9212 9.4668 12.2805 8.42635 12.2807 7.32845C12.2807 6.00537 11.7654 4.76139 10.8297 3.82585C9.89412 2.8903 8.65031 2.375 7.32707 2.375C6.00399 2.375 4.76001 2.8903 3.82446 3.82585C1.89315 5.75732 1.89315 8.8999 3.82446 10.8311C4.76001 11.7668 6.00399 12.2821 7.32707 12.2821C8.42497 12.2819 9.46541 11.9225 10.3232 11.2673L12.4853 13.4294C12.6153 13.5596 12.7861 13.6247 12.9566 13.6247C13.1272 13.6247 13.2979 13.5596 13.428 13.4294C13.6884 13.1691 13.6884 12.7469 13.428 12.4867ZM4.76717 9.88835C3.35571 8.47689 3.35588 6.18018 4.76717 4.76855C5.45093 4.08496 6.36011 3.70833 7.32707 3.70833C8.29419 3.70833 9.20321 4.08496 9.88696 4.76855C10.5707 5.45231 10.9473 6.36149 10.9473 7.32845C10.9473 8.29557 10.5707 9.20459 9.88696 9.88835C9.20321 10.5721 8.29419 10.9487 7.32707 10.9487C6.36011 10.9487 5.45093 10.5721 4.76717 9.88835Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2dc04596d8c99196b2e293bd793b8878.svg";
export { ForwardRef as ReactComponent };